/**
 * Invasión de Dorados (invasion:2) — ficha editorial autorizada por el staff.
 * Configuración exportada el 08/10/2026; documentada, NO comprobada dentro del juego.
 * Página de referencia visual (no sustituye mapas, horarios ni drops de Vanguard): muasean.org/cuoc-xam-luoc-vang/
 */

export const GOLDEN_EVENT_ID = 'invasion:2'
export const GOLDEN_PATH = '/guia/dorados'
export const GOLDEN_CONFIG_DATE = '08/10/2026'
export const GOLDEN_REFERENCE_URL = 'https://muasean.org/cuoc-xam-luoc-vang/'

export const goldenSchedule = {
  perDay: 4,
  everyHours: 6,
  durationMinutes: 30,
  timesVenezuela: ['00:00', '06:00', '12:00', '18:00'],
  activeOn: ['servermain1', 'servermain2'],
  inactiveOn: ['servercastle'],
  types: 19,
  perSpawn: 68,
  records: 24,
  area: { xMin: 10, xMax: 239, yMin: 10, yMax: 239 },
}

/** Variantes exactas de 14,11 que entregan los dorados. */
export const kundunBoxes = [
  { level: 1, id: '14,11@8', name: 'Box of Kundun 1', possibleItems: 67 },
  { level: 2, id: '14,11@9', name: 'Box of Kundun 2', possibleItems: 66 },
  { level: 3, id: '14,11@10', name: 'Box of Kundun 3', possibleItems: 79 },
  { level: 4, id: '14,11@11', name: 'Box of Kundun 4', possibleItems: 95 },
  { level: 5, id: '14,11@12', name: 'Box of Kundun 5', possibleItems: 75 },
] as const

export type GoldenMonster = {
  id: number
  name: string
  /** Cantidad por aparición y por subservidor. */
  count: number
  maps: string[]
  /** true = aparece en UNO de los mapas listados, no en todos a la vez. */
  oneOf?: boolean
  boxLevels: number[]
  drop: string
}

const box = (n: number) => `1 caja Kundun +${n}`

export const goldenMonsters: GoldenMonster[] = [
  { id: 43, name: 'Golden Budge Dragon', count: 4, maps: ['Lorencia'], boxLevels: [1], drop: box(1) },
  { id: 78, name: 'Golden Goblin', count: 5, maps: ['Noria'], boxLevels: [1], drop: box(1) },
  { id: 53, name: 'Golden Titan', count: 5, maps: ['Devias'], boxLevels: [1], drop: box(1) },
  { id: 54, name: 'Golden Soldier', count: 5, maps: ['Devias'], boxLevels: [1], drop: box(1) },
  { id: 502, name: 'Golden Rabbit', count: 5, maps: ['Elbeland'], boxLevels: [1], drop: box(1) },
  { id: 493, name: 'Golden Dark Knight', count: 5, maps: ['Dungeon'], boxLevels: [1], drop: box(1) },
  { id: 80, name: 'Golden Lizard King', count: 3, maps: ['Atlans'], boxLevels: [2], drop: box(2) },
  { id: 81, name: 'Golden Vepar', count: 5, maps: ['Atlans'], boxLevels: [2], drop: box(2) },
  { id: 494, name: 'Golden Devil', count: 3, maps: ['Lost Tower'], boxLevels: [2], drop: box(2) },
  { id: 79, name: 'Golden Derkon', count: 1, maps: ['Lorencia', 'Devias', 'Noria', 'Lost Tower', 'Elbeland'], oneOf: true, boxLevels: [3], drop: box(3) },
  { id: 82, name: 'Golden Tantalos', count: 3, maps: ['Tarkan'], boxLevels: [3], drop: box(3) },
  { id: 83, name: 'Golden Wheel', count: 5, maps: ['Tarkan'], boxLevels: [3], drop: box(3) },
  { id: 495, name: 'Golden Stone Golem', count: 3, maps: ['Aida'], boxLevels: [3], drop: box(3) },
  { id: 496, name: 'Golden Crust', count: 3, maps: ['Icarus'], boxLevels: [3], drop: box(3) },
  { id: 497, name: 'Golden Satyros', count: 3, maps: ['Kanturu 1'], boxLevels: [4], drop: box(4) },
  { id: 498, name: 'Golden Twin Tail', count: 3, maps: ['Kanturu 2'], boxLevels: [4], drop: box(4) },
  { id: 500, name: 'Golden Napin', count: 3, maps: ['Swamp of Calmness'], boxLevels: [5], drop: box(5) },
  { id: 499, name: 'Golden Iron Knight', count: 3, maps: ['Raklion 1'], boxLevels: [5], drop: box(5) },
  {
    id: 501,
    name: 'Great Golden Dragon',
    count: 1,
    maps: ['Kanturu 1', 'Raklion 1'],
    oneOf: true,
    boxLevels: [4, 5],
    drop: '5 cajas en total · cada caja: 50 % Kundun +4 o 50 % Kundun +5',
  },
]

export const goldenMonsterIds = goldenMonsters.map((m) => m.id)

/** Todos los mapas posibles, en orden de primera aparición. */
export const goldenMaps = Array.from(new Set(goldenMonsters.flatMap((m) => m.maps)))

/** Para el panel del staff: referencias técnicas de la configuración. */
export const goldenStaffNotes = [
  'event_id invasion:2 (27_events / 31_event_monsters / 32_event_spawn_rules / 30_event_map_choices).',
  'Bolsas internas 108–126: mecanismo de recompensa de cada monstruo; no son cajas que abre el jugador.',
  '24 registros de aparición incluyen mapas alternativos; no son 24 tipos ni se suman sus cantidades.',
  'Golden Archer (236) no pertenece a esta invasión en los archivos.',
  'Imágenes del JSON VANGUARD_DORADOS_DATOS_IMAGENES.json: pendientes (el archivo no llegó adjunto).',
]
